var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assignments-main"},[_c('BreadCrumb',{attrs:{"data":_vm.breadCrumb}}),_vm._v(" "),_c('div',{staticClass:"assignments-body"},_vm._l((_vm.users),function(user){return _c('UserCard',{key:user.id,attrs:{"user":user}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82466564","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Support/Ticket/Assignments.vue
// module id = null
// module chunks = 